import { render, staticRenderFns } from "./DeliveryOrderRelation.vue?vue&type=template&id=1b72c19f&scoped=true"
import script from "./DeliveryOrderRelation.vue?vue&type=script&lang=js"
export * from "./DeliveryOrderRelation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b72c19f",
  null
  
)

export default component.exports